import { Box, Chip, Grid, Paper, Stack, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import GlobalButton from "../../../components/CustomButton";
import PackageCard from "../../../components/Cards/PackageCard";

const AttachedBasePackages = ({
    selectedBasePackages,
    setSelectedBasePackages,
    attachedBasePackagesDialogRef,
}) => {
    const { t } = useTranslation(["blog", "common"]);

    const handleRemoveBasePackage = (basePackage) => {
        setSelectedBasePackages((prev) =>
            prev.filter((item) => item._id !== basePackage._id),
        );
    };

    return (
        <Paper
            elevation={0}
            sx={{
                mt: 3,
                p: 3,
                border: "1px solid",
                borderColor: "divider",
                borderRadius: 3,
            }}
        >
            <Stack
                direction={{ xs: "column", sm: "row" }}
                justifyContent="space-between"
                alignItems={{ xs: "flex-start", sm: "center" }}
                spacing={2}
            >
                <Box>
                    <Typography variant="h6" fontWeight={600}>
                        {t("attachedBasePackages", { ns: "blog" })}
                    </Typography>

                    <Typography variant="body2" color="text.secondary">
                        {t("optional", { ns: "common" })}
                    </Typography>
                </Box>

                <GlobalButton
                    btnText="addBasePackages"
                    handleClickBtn={() =>
                        attachedBasePackagesDialogRef?.current?.openDialog()
                    }
                    styleProps={{
                        width: "auto",
                        minWidth: 180,
                    }}
                />
            </Stack>

            {selectedBasePackages?.length > 0 ? (
                <Box mt={3}>
                    <Stack
                        direction="row"
                        alignItems="center"
                        justifyContent="space-between"
                        mb={2}
                    >
                        <Typography variant="body2" color="text.secondary">
                            {t("selectedBasePackagesCount", {
                                ns: "blog",
                                count: selectedBasePackages.length,
                            })}
                        </Typography>

                        <Chip
                            color="primary"
                            size="small"
                            label={`${selectedBasePackages.length} Selected`}
                        />
                    </Stack>

                    <Box
                        sx={{
                            p: 2,
                            borderRadius: 2,
                            bgcolor: "background.default",
                        }}
                    >
                        <Grid container spacing={2}>
                            {selectedBasePackages.map((basePackage) => (
                                <Grid item xs={12} sm={6} md={4} lg={3} key={basePackage._id}>
                                    <PackageCard
                                        cardData={basePackage}
                                        showRemove
                                        onRemove={handleRemoveBasePackage}
                                    />
                                </Grid>
                            ))}
                        </Grid>
                    </Box>
                </Box>
            ) : (
                <Box
                    mt={3}
                    sx={{
                        border: "1px dashed",
                        borderColor: "divider",
                        borderRadius: 2,
                        py: 4,
                        px: 2,
                        textAlign: "center",
                        bgcolor: "background.default",
                    }}
                >
                    <Typography variant="body2" color="text.secondary">
                        {t("noBasePackagesSelected", { ns: "common" })}
                    </Typography>

                    <Typography
                        variant="caption"
                        color="text.secondary"
                        display="block"
                        mt={1}
                    >
                        {t("clickAddBasePackagesToAttachBasePackages", { ns: "common" })}
                    </Typography>
                </Box>
            )}
        </Paper>
    );
};

export default AttachedBasePackages;